var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('select-input',{attrs:{"label":"Type","rules":{},"id":"type","options":_vm.types,"multiple":false},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }